import { Link } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import homePageStyles from "../../styles/homePage.module.css";
import HomePagePill from "./HomePagePill";
import { bagstageApplications } from "../../utils/commonUtil";

export default function HomePageLink({
  icon,
  title,
  redirectUrl,
  appRef,
  isSmallCard = false
}: {
  icon: React.ReactNode;
  title: string;
  redirectUrl: string;
  appRef: string;
  isSmallCard?: boolean;
}) {
  const { isLogin } = useAppSelector((state) => state.authenticationSlice);
  const { enabledProducts } = useAppSelector(
    (state) => state.enabledProductsSlice
  );
  return (
    <>
      {isLogin && enabledProducts?.includes(appRef) ? (
        <Link
          to={redirectUrl}
          className={`
            ${homePageStyles.appPill} 
            ${isSmallCard ? homePageStyles.smallCard : ""}
            `}
        >
          <HomePagePill icon={icon} title={title} />
        </Link>
      ) : (
        appRef !== bagstageApplications.arrivalCustoms && ( // never show customs in a disabled state
          <div
            className={`
            ${homePageStyles.appPill}   
            ${isSmallCard ? homePageStyles.smallCard : ""}
            cursor-not-allowed 
            opacity-50
            `}
          >
            <HomePagePill icon={icon} title={title} />
          </div>
        )
      )}
    </>
  );
}
